import { httpFaceClient, httpClient } from './index'
export const _apiOutLogin = (user_name, password) => {
  return httpClient.post(`out_api/login`,
    { user_name, password }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`))
    }
  })
}
export const users = (user_id, face, consume_token, meta_data) => {
  return httpFaceClient.post(`/users/`,
    {
      user_id, face, consume_token, meta_data
    }).then(res => {
    if (res.data.errno === 0) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error(`${res.data.msg}`))
    }
  })
}
export const _getFaceUsers = (api_key) => {
  console.log(`Bearer ${api_key}`)
  return httpFaceClient.get(`/users/`, {
    headers: {
      'Authorization': `Bearer ${api_key}`
    },
    crossdomain: true
  }).then(res => {
    console.log(res)
    if (res.data.errno === 0) {
      return Promise.resolve(res.data.users)
    } else {
      return Promise.reject(new Error(`${res.data.msg}`))
    }
  })
}

export const _addFaceUsers = ({ user_id, face, consume_token, meta_data }, api_key) => {
  return httpFaceClient.post(`/users/`, {
    user_id, face, consume_token, meta_data
  }, {
    headers: {
      Authorization: `Bearer ${api_key}`
    },
    crossdomain: true
  }).then(res => {
    console.log(res)
    if (res.data.errno === 0) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error(`${res.data.msg}`))
    }
  })
}
export const _getFaceUserDetail = (user_id, api_key) => {
  return httpFaceClient.get(`/users/${user_id}`, {
    headers: {
      Authorization: `Bearer ${api_key}`
    }
  }).then(res => {
    if (res.data.errno === 0) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error(`${res.data.msg}`))
    }
  })
}
export const _editFaceUser = ({ user_id, face, consume_token, meta_data }, api_key) => {
  console.log(user_id, face, consume_token, meta_data)
  return httpFaceClient.put(`users/`,
    { user_id, face, consume_token, meta_data }, {
      headers: {
        Authorization: `Bearer ${api_key}`
      }
    }).then(res => {
    if (res.data.errno === 0) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error(`${res.data.msg}`))
    }
  })
}
export const _deleteFaceUser = (user_id, api_key) => {
  return httpFaceClient.delete(`users/${user_id}`, {
    headers: {
      Authorization: `Bearer ${api_key}`
    }
  }).then(res => {
    if (res.data.errno === 0) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error(`${res.data.msg}`))
    }
  })
}
